import {  StartPageTileImageApi } from "../openapi";
import openApiConfig from "./http_service";

const startPageImageTileApi=new StartPageTileImageApi(openApiConfig)

export default startPageImageTileApi